export const SIDEBAR_AFFILIATE_PARTICIPANT_GROUP_LABEL = 'Afiliados'
export const SIDEBAR_DISTRIBUTOR_PARTICIPANT_GROUP_LABEL = 'Distribuidores'

/** Rotas de gestão da instituição exibidas apenas com ao menos uma campanha criada. */
export const SIDEBAR_PATHS_REQUIRING_CAMPAIGN = new Set([
  '/afiliados',
  '/meus-distribuidores',
  '/clientes/lista',
  '/pedidos/lista',
  '/conversoes-meta',
  '/buscar-ganhador',
])

export const INSTITUTION_CAMPAIGNS_UPDATED_EVENT =
  'legalprime:institution-campaigns-updated' as const

export function institutionHasAtLeastOneCampaign(campaignCount: number): boolean {
  return campaignCount > 0
}

/** Notifica ouvintes (ex.: sidebar) para reavaliar itens dependentes de campanha. */
export function notifyInstitutionCampaignsUpdated(): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(INSTITUTION_CAMPAIGNS_UPDATED_EVENT))
}

export function isSidebarPathRequiringCampaign(path: string): boolean {
  return SIDEBAR_PATHS_REQUIRING_CAMPAIGN.has(path)
}

export function isSidebarAffiliateParticipantGroup(groupLabel: string): boolean {
  return groupLabel === SIDEBAR_AFFILIATE_PARTICIPANT_GROUP_LABEL
}

export function isSidebarDistributorParticipantGroup(groupLabel: string): boolean {
  return groupLabel === SIDEBAR_DISTRIBUTOR_PARTICIPANT_GROUP_LABEL
}
